import { render, staticRenderFns } from "./SearchItems.vue?vue&type=template&id=6651e056&scoped=true"
import script from "./SearchItems.vue?vue&type=script&lang=js"
export * from "./SearchItems.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SearchItems.vue?vue&type=style&index=0&id=6651e056&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "6651e056",
  null
  ,true
)

export default component.exports